// Required in Amplify v6 to enable automatic OAuth callback handling.
// Without this import, signInWithRedirect won't process the ?code= parameter
// on redirect, causing "User cancelled OAuth flow" errors.
// See: https://github.com/aws-amplify/amplify-js/issues/12651
import 'aws-amplify/auth/enable-oauth-listener';

import { Amplify } from 'aws-amplify';

import { getEnvVar } from '@/shared/utils/envVarConfig';
import { getOAuthRedirectUrls } from '@/shared/utils/platform';

const { signIn, signOut } = getOAuthRedirectUrls();

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: getEnvVar('VITE_COGNITO_USER_POOL_ID'),
      userPoolClientId: getEnvVar('VITE_COGNITO_CLIENT_ID'),
      loginWith: {
        oauth: {
          domain: getEnvVar('VITE_COGNITO_DOMAIN'),
          redirectSignIn: [signIn],
          redirectSignOut: [signOut],
          responseType: 'code',
          scopes: ['openid', 'email', 'phone'],
        },
      },
    },
  },
});
